import React, { useState } from "react";
import SidebarAdmin from '../../components/admin/Sidebar';
import LoadingScreen from "../../components/LoadingScreen";
import NotFound from "../../components/NotFound";
import "../../css/seller/produk.css"
import "../../css/admin/produk.css"
import "../../css/card.css"
import { useNavigate } from 'react-router';
import DeleteConfirm from "../../components/DeleteConfirm";
import { useCookies } from 'react-cookie';
import Alert from "../../components/Alert";

export default function AdminDaftarProduk() {
  const [isLoading, setIsLoading] = useState(false);
  const [Data, setData] = useState([])
  const navigate = useNavigate();
  const [confirmActive, setConfirmActive] = useState(false);
  const [imgId, setImgId] = useState();
  const [productId, setproductId] = useState();
  const [cookies, setCookie] = useCookies(['accessToken']);
  const [alertActive, setAlertActive] = useState(true);
  const [alert, setAlert] = useState({});
  const [filter, setFilter] = useState('')

  const activateAlert = () => {
    setAlertActive(true);
    setTimeout(() => {
      setAlertActive(false);
    }, 3000);
  };

  React.useEffect(() => {
    const fetchProduct = async (filter) => {
      try {
        setIsLoading(true);
        setData('')
        let url = 'https://w-shop-backend.vercel.app/api/products?';
        if (!!filter) {
          const params = new URLSearchParams();
          for (const [key, value] of Object.entries(filter)) {
            params.set(key, value);
          };
          url += params.toString();
        };
        const response = await fetch(url, {
          method: 'GET',
        })
        const body = await response.json();
        if (body.status !== "success") {
          throw new Error(body.message);
        }
        const product = body.data;
        product.sort((a, b) => a.id - b.id);
        setData(product);
        setIsLoading(false);
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      };
    }
    fetchProduct({ product: filter })
  }, [filter])

  const handleDeleteProduct = async (idProduct, idImg) => {
    try {
      const url = `https://w-shop-backend.vercel.app/api/products/${idProduct}`;
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          "Content-type": "application/json",
          Authorization: "Bearer " + cookies.accessToken,
        },
      });
      const body = await response.json();
      if (body.status !== "success") {
        throw new Error(body.message);
      } else {
        const urlImg = `https://w-shop-backend.vercel.app/api/images?type=PRODUCT_IMG&imageId=${idImg}`;
        await fetch(urlImg, {
          method: 'DELETE',
          headers: {
            'Authorization': 'Bearer ' + cookies.accessToken,
          },
        })
        const event = {
          type: "alert",
          alert: {
            type: "success",
            message: "Produk ditambahkan ke keranjang",
          },
        };
        setCookie("event", event, { path: "/" });
        setAlert(event.alert);
        activateAlert();
        handleHideConfirm();
        window.location.reload();
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      setAlert({
        type: "danger",
        message: "Error: " + error.message,
      });
      activateAlert();
    }
  };

  const handleShowConfirm = (idImg, idProduct) => {
    setConfirmActive(true);
    setproductId(idProduct);
    setImgId(idImg);
  };

  const handleHideConfirm = () => {
    setConfirmActive(false);
  };

  const rupiah = (number) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR"
    }).format(number);
  }

  let adminProduct = (
    <div className=" p-5">
      <DeleteConfirm
        active={confirmActive}
        message="Ingin menghapus produk ini ?"
        cancelHandler={handleHideConfirm}
        buttonMessage='Hapus'
        deleteHandler={() => {
          handleDeleteProduct(productId, imgId);
        }}
      />
      <LoadingScreen active={isLoading} />

      <div style={{ backgroundColor: "white", borderRadius: "10px" }} className=" p-5">
        <h1 className="daftarProdukAdmin">Daftar Produk</h1>
        <form className="d-md-flex justify-content-between d-blok" role="search">
          <div className="d-flex  my-2">
            <input className="form-control inputSearch me-md-3 m-0 " type="search" placeholder="Cari" aria-label="Search" onChange={(e) => { setFilter(e.target.value) }} />
            <button  className="btn btn-search btn-primary" type="submit" style={{ width: "90px" }}>
              <img src={"/img/icon-search.png"} className="imgSearch" alt="img-logo" ></img>
            </button>
          </div>
        </form>
      </div>

      <div className='row pt-5 px-5' style={{ minHeight: "700px" }}>
        {
          Data.length > 0 ? (
            Data.map((data) => (
              <div key={data.id} className="col">
                <div href='/search/detailSearch' className="card mb-5" style={{ width: "256px", height: "379px", textDecoration: "none" }}>
                  <img src={data.imgUrl} className="card-img-top" alt="..." style={{ height: "216px" }} />
                  <div className="card-body">
                    <h6 className='cardTitle'>{data.product}</h6>
                    <h6 className='cardPrice '>{rupiah(data.price)}</h6>
                    <p className='cardTitle'>{data.seller.shopName}</p>
                    <button className="bEdit btn btn-outline-primary" onClick={() => { navigate('/search/detailSearch/' + data.id) }}>Lihat</button>
                    <button className="bHapus btn btn-outline-danger ms-3" onClick={() => { handleShowConfirm(data.imgId, data.id) }}>Hapus</button>
                  </div>
                </div>
              </div>
            ))) : (
            <NotFound />
          )
        }
      </div>
      <Alert active={alertActive} type={alert.type} message={alert.message} />
    </div>
  )

  return (
    <div>
      <SidebarAdmin components={adminProduct} titleAppBar={"Produk"} />
    </div>
  );
}
